import React from 'react';
import { IdsButton, IdsIcon } from '@investec/ids-web-react';
import { formatCurrency } from '../../../../utils/helpers';

const InstantAccessCashIsaWithdrawalConfirmation = ({ account, onConfirm, onCancel }) => (
    <section className="disa-closure__content disa-closure__withdrawal-confirmation">
        <h2>Important information</h2>
        <p className="disa-closure__information-intro">If you choose to go ahead:</p>
        <ul className="disa-closure__information-list">
            <li><IdsIcon name="thumbs-down" size="md" alt="" /><span>You&apos;ll lose the ISA tax benefits on the full amount you withdraw. For example, if you deposit £5,000 and choose to withdraw it, you&apos;ll lose the tax-free status on that entire amount.</span></li>
            <li><IdsIcon name="thumbs-down" size="md" alt="" /><span>Closing this account means you won&apos;t be able to open another Instant Access Cash ISA.</span></li>
            <li><IdsIcon name="thumbs-up" size="md" alt="" /><span>Once your account is closed, you&apos;ll still be able to access your Investec dashboard to download your annual statements and interest certificates.</span></li>
            <li><IdsIcon name="thumbs-up" size="md" alt="" /><span>You can open another Fixed Rate Cash ISA with us in the future, if you choose to.</span></li>
        </ul>
        <div className="disa-closure__final-payment" data-di-mask>
            <strong>Your final payment</strong>
            <p>Current balance including interest earned to date</p>
            <b>{formatCurrency(account.balance || 0)}</b>
        </div>
        <p className="disa-closure__confirmation">When you&apos;re ready, select &apos;Close my account&apos; to confirm.</p>
        <div className="disa-closure__actions">
            <IdsButton appearance="primary" size="md" onClick={onConfirm}>Close my account</IdsButton>
            <IdsButton appearance="subtle" size="md" onClick={onCancel}>Don&apos;t close my account</IdsButton>
        </div>
    </section>
);

export default InstantAccessCashIsaWithdrawalConfirmation;
